import dayjs from 'dayjs'

import { LoteInputProps, LoteOutputProps } from '../interfaces'

export const loteRegistroComposeService = (input: LoteInputProps): LoteOutputProps => {
  return {
    // codigoLote: input.codigoLote,
    descripcion: input.descripcion,
    fechaAdmision: dayjs(input.fechaAdmision).format('DD/MM/YYYY HH:mm:ss').toString(),
    fechaFabricacion: dayjs(input.fechaFabricacion).format('DD/MM/YYYY').toString(),
    fechaVencimiento: dayjs(input.fechaVencimiento).format('DD/MM/YYYY').toString(),
    atributo1: input.atributo1,
    atributo2: input.atributo2,
  }
}
